<!-- Prime Toggle Bar -->
<div class="prime-toggle-bar ion-margin marb10 mart10" [class.active]="isPrimeEnabled">
  <div class="prime-toggle-container">
    <div class="prime-toggle-left">
      <div class="prime-toggle-switch">
        <div class="toggle-track" [class.active]="isPrimeEnabled" (click)="togglePrime()">
          <div class="toggle-knob"></div>
        </div>
        <img src="https://img.travelx.ai/bfl/prime_logo.png" alt="Prime" class="prime-logo">
      </div>
    </div>
    <div class="prime-toggle-right">
      <button class="prime-discount-btn" (click)="onGetPrimeDiscount()">
        <span class="discount-text">
          {{ enabledOffer?.title || enabledCampaign?.offerTitle || "Get Additional Discount with prime" }}
        </span>
        <!-- <span class="discount-text" *ngIf="!isPrimeEnabled">Get Additional</span>
        <span class="discount-text" *ngIf="!isPrimeEnabled">discount with prime</span>
        <span class="discount-text" *ngIf="isPrimeEnabled">Up to ₹500 Additional</span>
        <span class="discount-text" *ngIf="isPrimeEnabled">discount on domestic flights</span> -->
      </button>
    </div>
  </div>
</div>
